import {camelizeKeys} from 'humps';
import {TasksResponseType, TaskDetailsModelDTO} from 'shared/models/task/task';

export const mapActivitiesToSelectTaskOptions = (data: TasksResponseType) =>
  data.map((task) => {
    const _task = camelizeKeys(task) as TaskDetailsModelDTO;
    return {value: _task.id, uniqId: _task.id, label: _task.name};
  });
